import { Tab, TabGroup, TabList } from '@headlessui/react';

import { cn } from 'support/helpers/cn/cn';

type TabsListProps = {
  tabs: Array<{ label: string; badge?: string | number; route?: string }>;
  onChange: (index: number) => void;
  selected: number;
  className?: string;
};

export function TabsList({ tabs, onChange, selected, className }: TabsListProps) {
  return (
    <TabGroup onChange={onChange} defaultIndex={0} selectedIndex={selected} className="w-full">
      <TabList>
        <div className="hidden sm:block">
          <div className={cn('border-b border-gray-200', className)}>
            <nav className="-mb-px flex" aria-label="Tabs">
              {tabs.map((tab) => (
                <Tab
                  key={tab.label}
                  className={({ selected }) =>
                    cn(
                      'border-b-2 p-4 text-sm font-medium whitespace-nowrap focus:outline-hidden',
                      selected
                        ? 'border-gray-700 text-gray-900 '
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 ',
                    )
                  }
                >
                  {tab.label}

                  {tab.badge ? (
                    <span className="ml-2 rounded-full bg-gray-100 px-2 py-1 font-medium text-gray-800">
                      {tab.badge}
                    </span>
                  ) : null}
                </Tab>
              ))}
            </nav>
          </div>
        </div>
      </TabList>
    </TabGroup>
  );
}
